import { render, staticRenderFns } from "./OrgHomeStatsInventory.vue?vue&type=template&id=4dbf4f74&"
import script from "./OrgHomeStatsInventory.vue?vue&type=script&lang=js&"
export * from "./OrgHomeStatsInventory.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeStatsInventory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports